module.exports = __webpack_public_path__ + "img/arrow-left-dark-white.9a05f901.svg";